<div #mapElement class="app-store-map"></div>
